import React from "react";
import { Helmet } from "react-helmet";
import GuestNav from "./Navbars/GuestNav";
import Footer from "../MyComponents/Footer";
import "./Gallery.css";

// Importing images
import galleryIconLeft from "../assets/galleryicon.png";
import galleryIconRight from "../assets/galleryicon1.png";
import kid7 from "../assets/kid7.png";
import kid8 from "../assets/kid8.png";
import kid9 from "../assets/kid9.png";
import kid10 from "../assets/kid10.png";
import kid11 from "../assets/kid11.png";
import kid12 from "../assets/kid12.png";
import kid13 from "../assets/kid13.png";
import kid14 from "../assets/kid14.png";
import kid24 from "../assets/kid24.png";
import kid25 from "../assets/kid25.png";
import kid26 from "../assets/kid26.png";

const Gallery = () => {
  const galleryImages = [
    kid7,
    kid8,
    kid9,
    kid10,
    kid11,
    kid12,
    kid13,
    kid14,
    kid24,
    kid25,
    kid26,
  ];

  return (
    <>
      <Helmet>
        <title>Polymath-Kids Gallery - Explore Student Achievements</title>
        <meta
          name="description"
          content="Dive into the Polymath-Kids Gallery showcasing student achievements in coding, artwork, and design. See real examples of creativity and innovation."
        />
        <meta name="keywords" content="Polymath-Kids, gallery, student projects, coding, artwork, design, education" />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <GuestNav />
      <main className="gallery-main">
        {/* Section 1 */}
        <section className="gallery-intro">
          <div className="gallery-intro-content">
            <h1 className="gallery-heading">
              <span className="highlight-purple">Explore Our Creative</span>
              <br />
              <span className="highlight-pink">Gallery</span>
            </h1>
            <p className="gallery-description">
              Dive into a colorful showcase of student achievements, from
              interactive projects and coding creations to artwork and design.
              This gallery highlights the diverse talents nurtured through
              Polymath-Kids programs, reflecting the creativity, problem-solving,
              and hands-on learning that students experience. Browse through real
              examples of innovation and be inspired by the imagination and
              dedication of young minds shaping the future.
            </p>
          </div>
          <img
            src={galleryIconLeft}
            alt="Gallery Icon Left"
            className="gallery-icon-left"
          />
          <img
            src={galleryIconRight}
            alt="Gallery Icon Right"
            className="gallery-icon-right"
          />
        </section>

        {/* Section 2 */}
        <section className="gallery-section">
          <h2 className="gallery-title">
            <span className="highlight-purple">Gallery of </span>
            <span className="highlight-pink">Learning & Growth</span>
          </h2>
          <div className="gallery-grid">
            {galleryImages.map((imgSrc, index) => (
              <div className="gallery-item" key={index}>
                <img src={imgSrc} alt={`Student work ${index + 1}`} />
              </div>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Gallery;